import { gql } from '@apollo/client';

// Fragment for campaign basic info
export const CAMPAIGN_BASIC_FRAGMENT = gql`
  fragment CampaignBasicInfo on Campaign {
    id
    name
    orderNumber
    statusId
    signedDate
    createdDate
    lastUpdated
    estimatedStartDate
    estimatedEndDate
    evergreen
    evergreenCancelDate
    campaignDuration
    bonusMonths
    genericArtwork
    timeSensative
    takedownPriorityDays
    contractedKioskTotal
    surplusKioskTotal
  }
`;

// Fragment for campaign with status
export const CAMPAIGN_WITH_STATUS_FRAGMENT = gql`
  fragment CampaignWithStatus on Campaign {
    ...CampaignBasicInfo
    status {
      id
      statusName
    }
  }
  ${CAMPAIGN_BASIC_FRAGMENT}
`;

// Fragment for campaign kiosks
export const CAMPAIGN_KIOSKS_FRAGMENT = gql`
  fragment CampaignKiosksInfo on Campaign {
    campaignKiosks {
      id
      quantity
      startDate
      endDate
      active
      kiosk {
        id
        kioskName
        venue {
          id
          venueName
          city
          state
        }
      }
    }
  }
`;

// Get customer campaigns (for campaign list)
export const GET_CUSTOMER_CAMPAIGNS = gql`
  query GetCustomerCampaignsForCustomer(
    $first: Int
    $after: String
  ) {
    customerCampaignsForCustomer(
      first: $first
      after: $after
      order: { createdDate: DESC }
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        name
        status {
          id
          statusName
        }
        statusId
        createdDate
        estimatedStartDate
        estimatedEndDate
        signedDate
        campaignDuration
        bonusMonths
        evergreen
        evergreenCancelDate
        customerCampaigns {
          customerLoginId
          customerId
          customerLogin {
            id
            email
            customer {
              id
            }
          }
        }
      }
    }
  }
`;

// Get a specific campaign by ID
export const GET_CUSTOMER_CAMPAIGN_BY_ID = gql`
  query GetCustomerCampaignById($campaignId: Int!) {
    customerCampaignsForCustomer(
      where: { id: { eq: $campaignId } }
    ) {
      nodes {
        id
        name
        orderNumber
        statusId
        evergreen
        evergreenCancelDate
        campaignDuration
        bonusMonths
        status {
          id
          statusName
        }
        signedDate
        createdDate
        lastUpdated
        estimatedStartDate
        estimatedEndDate
        cancellations {
          cancelReasons
          cancelText
          name
          phone
          email
          createDate
          cancellationStatusNavigation {
            statusName
          }
        }
        customerCampaigns {
          customerLoginId
          customerId
          customerLogin {
            id
            firstName
            lastName
            email
            userName
            customer {
              id
              companyName
              phone
              website
            }
          }
        }
        campaignPaymentMethods {
          id
          customerPaymentMethodId
          customerPaymentMethod {
            id
            fullName
            lastFour
          }
        }
      }
    }
  }
`;

// Get campaigns count
export const GET_CUSTOMER_CAMPAIGNS_COUNT = gql`
  query GetMyCampaignsCount {
    customerCampaignsForCustomer {
      totalCount
    }
  }
`;

// Get campaign users/team members
export const GET_CAMPAIGN_USERS = gql`
  query GetCampaignUsers($campaignId: Int!) {
    campaignUsers(campaignId: $campaignId) {
      campaignRoleType
      user {
        id
        firstName
        lastName
        email
        phone
      }
    }
  }
`;

// Get paid evergreen bills count for a campaign
export const GET_PAID_EVERGREEN_BILLS = gql`
  query GetPaidEvergreenBills($campaignId: Int!) {
    paidEvergreenBillsCount(campaignId: $campaignId)
  }
`;

